module.exports = __webpack_public_path__ + "static/img/2015.19f3971.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/2015.png
// module id = t/4M
// module chunks = 1